export default __webpack_public_path__ + "ad87cfd0642c27c592ed8b95870c47fa.jpg";